var e = /* @__PURE__ */ ((i) => (i.price = "price", i.quantity = "quantity", i.weight = "weight", i))(e || {});
export {
  e as ShippingRuleTypeEnum
};
